/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import sprite from './sprite.css';
import classNames from 'classnames';
import { StyleMode } from '../../../editor/src/js/constants/float-toobbar-data';
import { MenuType } from '../../../../slide/domain/ui-model/constant/menu';

interface ItemIconProps {
    disable: number;
    disabled: boolean;
    id: string;
    title: string;
    model: typeof StyleMode[keyof typeof StyleMode];
    onItemClickCallBack: (type: string, id: string, what, e) => void;
}

interface ItemIconState {
    tooltipVisible: boolean;
}

/**
 * shape菜单
 */
export default class ItemIcon extends Component<ItemIconProps, ItemIconState> {
    public constructor(props) {
        super(props);
        this.state = {
            tooltipVisible: false,
        };
    }

    public render() {
        const itemClass = classNames({
            [sprite.icon]: true,
            [sprite[`icon-${this.changeType()}`]]: true,
            [sprite.gray]: this.props.disable > 1 || this.props.disabled,
        });
        const isQuickModel = this.props.model === StyleMode.QUICK_SETTING;

        return (
            <Tooltip
                style={{ margin: isQuickModel ? 6 : 0 }}
                key={`tip-${this.props.id}`}
                title={this.props.title}
                placement={'bottom'}
                overlayStyle={{ zIndex: 99999 }}
            >
                <div
                    onMouseDown={this.handleMouseDown}
                    className={sprite.sub}
                >
                    <span className={itemClass} />
                </div>
            </Tooltip>
        );
    }

    private changeType() {
        switch (this.props.id) {
            case ActionType.ALIGN_HORIZONTALLT_LEFT:
                return 'left';
            case ActionType.ALIGN_HORIZONTALLT_CENTER:
                return 'hcenter';
            case ActionType.ALIGN_HORIZONTALLT_RIGHT:
                return 'right';
            case ActionType.ALIGN_VERTICALLY_TOP:
                return 'top';
            case ActionType.ALIGN_VERTICALLY_CENTER:
                return 'vcenter';
            case ActionType.ALIGN_VERTICALLY_BOTTOM:
                return 'bottom';
            case ActionType.ALIGN_DISTRIBUTE_HORIZONTALLT:
                return 'dhorizontal';
            case ActionType.ALIGN_DISTRIBUTE_VERTICALLY:
                return 'dvertical';
            default :
                return this.props.id;
        }
    }

    private handleMouseDown = (e) => {
        if (this.props.disable > 1 || this.props.disabled) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
        this.props.onItemClickCallBack(MenuType.FLOAT, this.props.id, null, e);
    };
}
